import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['trigger']
  static values = {
    sidebarClass: { type: String, default: 'sidebar' }
  }

  connect() {
    // Try to find sidebar by custom class first, then fallback to default
    const sideBar = document.querySelector(`.${this.sidebarClassValue}`) ||
                    document.querySelector('.sidebar') ||
                    document.querySelector('.customers-sidebar')

    const closeButton = document.querySelector('.close-sidebar')

    if (sideBar) {
      this.triggerTarget.addEventListener('click', event => {
        sideBar.classList.toggle('active')
      })

      if (closeButton) {
        closeButton.addEventListener('click', event => {
          sideBar.classList.toggle('active')
        })
      }
    }
  }
}
